import type { ModalFuncProps } from 'antd/es/modal/interface';
import type { TFunction } from 'i18next';

import KeyboardShortcutsForm from '../../components/Forms/KeyboardShortcutsForm';

type ModalConfirm = (props: ModalFuncProps) => { destroy: () => void };

/**
 * Opens the keyboard shortcuts reference modal (same as sidebar footer / Primary+/).
 */
export function openKeyboardShortcutsFormModal(params: {
  modal: { confirm: ModalConfirm };
  t: TFunction;
}): void {
  const { modal, t } = params;
  const modalInstance = modal.confirm({
    centered: true,
    closable: true,
    content: <KeyboardShortcutsForm onClose={() => modalInstance.destroy()} />,
    destroyOnHidden: true,
    footer: null,
    icon: null,
    title: t('shortcuts.title'),
    width: 720,
  });
}
